<template>
    <div v-if="deleteReps">
        <div class="delete-rep-item">
            <div class="row">
                <div class="col-6 font-weight-bold">
                    # {{ deleteRepItem.rep_number }} - Rating: {{ deleteRepItem.score }}
                </div>
                <div class="col-6 text-right">{{ deleteRepItem.createdAt | formatDate }} </div>
            </div>
            <div class="row">
                <div class="col-6">Mentor: {{ deleteRepItem.mentor_name }}</div>
            </div>
            <div class="row mt-2">
                <div class="col-6 font-weight-bold">Comment:</div>
                <div class="col-6 text-right font-weight-bold">Time on Task: </div>
            </div>
            <div class="row">
                <div class="col-6">{{ deleteRepItem.comment }}</div>
                <div class="col-6 text-right">{{ deleteRepItem.timeOnTask | formatHourMin }}</div>
            </div>
        </div>

        <div class="row justify-content-center mt-4">
            <button type="button" class="btn btn-sm delete-rep-btn text-center" @click="onDeleteRepItem(deleteRepItem.id)">Delete</button>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import moment from 'moment';
import axios from 'axios';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

Vue.filter('formatHourMin', function(value) {
  if (value) {
      let hour = Math.floor(value/60);
      let min = (value%60);
      let timeTask; 

      if (hour > 0) {
        timeTask = hour + ' Hour(s) ' + min + ' Minutes' ;
      }
      else {
        timeTask = min + ' Minutes' ;  
      }
    return timeTask;
  }
});
export default {
    props: ['deleteRepItem', 'deleteReps'],
    methods: {
        onDeleteRepItem(id) {
            axios('/mentee/ratingrepetition/delete/' + id,
            {
                method: 'DELETE',
            })
            .then(() => {
                this.flash({ message: 'Repetition deleted successfully', variant: 'success' });
                this.$parent.navigate();
            })
            .catch((error) => {
                console.log(error)
            });
        }
    }
}
</script>
<style scoped>
.delete-rep-item {
  background-color: #e8e8e8 !important;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 40px 0 10px 0;
}
.delete-rep-btn {
  color: #FFF; 
  background-color: #FF0000 !important;
  border: 1px solid #FF0000 !important;
  border-radius: 10px;
  font-weight: 900;
  width: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/delete_repetition.vue